<script lang="ts">
  interface Props {
    onclick?: (e: MouseEvent) => void;
  }

  let { onclick }: Props = $props();
</script>

<div class="comp-help-text">
  <div class="label">
    <div class="info">* Info used to perform a verification from the primary source.</div>
    <div class="text">
      To change this information <button class="button" onclick={(e) => { e.preventDefault(); onclick?.(e); }}
        >run a new verification.</button
      >
    </div>
  </div>
</div>

<style>
  .comp-help-text {
    font-size: 11px;
    line-height: 18px;
    color: var(--grey-medium);
  }
  .text {
    display: flex;
    color: var(--grey-medium);
  }
  .text .button {
    margin-left: 5px;
    color: var(--grey-medium);
    text-decoration: underline;
  }
</style>
